const isValidEmail = (email: string) =>
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email.toLowerCase()
    );

const isNotEmpty = (data: string) => /\S/.test(data);

const isValidZip = (data: string) => data.length >= 4 && isNotEmpty(data);

export default {
    isValidEmail,
    isNotEmpty,
    isValidZip,
};
